import { connect } from "react-redux";
import React, { useRef, useState } from "react";
import { Button, ModalHeader, ModalBody } from "reactstrap";
import enhancer from "./enhancer/StaffEnhancer";
import { compose } from "redux";
import { addStaff, editStaff } from "services/staffServices";
import NavigationActions from "redux/navigation/actions";
import { useEffect } from "react";
import Loader from "components/Loader";
import Select from "react-select";
import { getServiceByVenue } from "services/serviceServices";
import PlaceHolderImage from "../../../assets/images/placeholder.png";

const { success, error } = NavigationActions;

const StaffModal = props => {
  const { isEdit } = props;
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    setFieldValue,
    isValid,
    setValues,
    onClose,
    toggleRefresh,
    setFieldError,
    handleSubmit,
    editData
  } = props;

  const [loading, setLoading] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const fileInputRef = useRef(null);

  // console.log(serviceData)

  const StaffHandler = async e => {
    e.preventDefault();
    handleSubmit();
    if (isValid) {
      const formData = new FormData();
      formData.append("file_image", values.file_image);
      formData.append("name", values.name);
      formData.append("email", values.email.toLowerCase());
      formData.append("phone", values.phone);
      if (Array.isArray(values.service_data)) {
        formData.append(
          "service_data",
          JSON.stringify(values.service_data.map(item => item.value))
        );
      } else if (values.service_data) {
        formData.append("service_data", values.service_data);
      } else {
        formData.append("service_data", "");
      }
      formData.append("status", values.status);
      formData.append(
        "is_manager",
        values.is_manager !== undefined ? values.is_manager : false
      );

      setLoading(true);
      isEdit
        ? await editStaff(token, values._id, formData).then(res => {
            if (res.success) {
              success(res.message);
              // console.log(res, "edit response")
              toggleRefresh(true);
              onClose();
            } else {
              error(res.message);
            }
            setLoading(false);
            // setValues({});
          })
        : await addStaff(token, formData).then(res => {
            if (res.success) {
              // console.log("add response", res);
              success(res.message);
              toggleRefresh(true);
              onClose();
            } else {
              error(res.message);
            }
            setLoading(false);
            // setValues({});
          });
    }
  };

  const handleImageChange = e => {
    if (e.target.files.length !== 1) {
      return;
    }
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    // Check if the selected file type is allowed
    if (!allowedTypes.includes(file.type)) {
      setFieldError(e.target.name, "Only .jpg, .jpeg, .png files are allowed.");
      // error("Only .jpg, .jpeg, .png files are allowed.");
      e.target.value = "";

      return;
    }
    // check if file is less than 2MB
    if (file.size > 2 * 1024 * 1024) {
      setFieldError(e.target.name, "File size should be less than 2MB.");
      // error("File size should be less than 2MB.");
      e.target.value = "";
      return;
    }

    // Set the selected file in Formik if the file type is valid
    setFieldValue(e.target.name, file);
    fileInputRef.current.value = "";
  };

  const getServiceData = async () => {
    await getServiceByVenue(token)
      .then(res => {
        let serviceArr = res.data?.map(val => {
          return { value: val._id, label: val.name };
        });
        setServiceData(serviceArr);
      })
      .catch(err => {
        error(err.message);
      });
  };

  // Function to convert service_data array to select options format
  const convertServiceDataToOptions = (serviceIds, availableServices) => {
    if (!Array.isArray(serviceIds) || !Array.isArray(availableServices)) {
      return [];
    }

    return serviceIds.map(serviceId => {
      const service = availableServices.find(s => s.value === serviceId);
      return service || { value: serviceId, label: `Service ${serviceId}` };
    });
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  useEffect(() => {
    getServiceData();
  }, []);

  useEffect(() => {
    if (isEdit && editData) {
      setValues({ ...editData });
    } else if (!isEdit) {
      setFieldValue("is_manager", true);
    }
  }, [editData, isEdit, setValues, setFieldValue]);

  // Separate useEffect to handle service data setting after services are loaded
  useEffect(() => {
    if (
      isEdit &&
      editData &&
      serviceData.length > 0 &&
      editData.service_data &&
      Array.isArray(editData.service_data)
    ) {
      // Convert service IDs to select options format
      const selectedServices = convertServiceDataToOptions(
        editData.service_data,
        serviceData
      );
      setFieldValue("service_data", selectedServices);
    }
  }, [serviceData, isEdit, editData]);

  return (
    <>
      <ModalHeader toggle={() => onClose()}>
        {isEdit ? "Edit" : "Add"} Staff
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group">
            <label>
              Name <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="name"
              onChange={handleChange}
              value={values.name}
              onBlur={handleBlur}
              placeholder="Staff Name"
            />
            <Error field="name" />
          </div>
          <div className="form-group">
            <label>
              Email <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="email"
              onChange={handleChange}
              value={values.email}
              onBlur={handleBlur}
              placeholder="Staff email"
              disabled={isEdit ? true : false}
            />
            <Error field="email" />
          </div>
          <div className="form-group">
            <label>
              Phone <span className="red">*</span>
            </label>
            <input
              type="text"
              className="form-control react-form-input"
              id="phone"
              onChange={handleChange}
              value={values.phone}
              onBlur={handleBlur}
              placeholder="Staff phone"
            />
            <Error field="phone" />
          </div>
          <div className="form-group">
            <label>
              Is Manager <span className="red">*</span>
            </label>
            <select
              className="detail-input-select custom-select"
              value={
                values?.is_manager === undefined ? true : values.is_manager
              }
              name="is_manager"
              onChange={e => {
                const val = e.target.value === "true";
                setFieldValue("is_manager", val);
                if (val) setFieldValue("service_data", []);
              }}
              onBlur={handleBlur}
            >
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </select>
            <Error field="is_manager" />
          </div>
          {values.is_manager === false && (
            <div className="form-group">
              <label>
                Services <span className="red">*</span>
              </label>
              <Select
                value={
                  Array.isArray(values.service_data) ? values.service_data : []
                }
                isMulti
                name="service_data"
                options={serviceData}
                className="basic-multi-select w-100"
                classNamePrefix="select"
                onChange={selected => {
                  setFieldValue("service_data", selected || []);
                }}
                placeholder="Select services"
              />
              <Error field="service_data" />
            </div>
          )}
          <div className="form-group">
            <label>Image</label>
            <br />
            <input
              ref={fileInputRef}
              type="file"
              id="file_image"
              name="file_image"
              className="form-control react-form-input"
              accept="image/*"
              onChange={handleImageChange}
              onBlur={handleBlur}
            />
            <Error field="file_image" />
            {values?.file_image && (
              <>
                <br />
                <img
                  src={
                    values?.file_image instanceof Blob
                      ? URL.createObjectURL(values?.file_image)
                      : `${process.env.REACT_APP_UPLOAD_DIR}${values?.file_image}`
                  }
                  className="profile-img"
                  alt="no"
                  width={100}
                  onError={e => {
                    e.target.src = PlaceHolderImage;
                  }}
                />
                <br />
              </>
            )}
          </div>
          <div className="form-group">
            <label>
              Status <span className="red">*</span>
            </label>
            <select
              className="detail-input-select custom-select"
              value={values?.status}
              name="status"
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <option value={true}>Active</option>
              <option value={false}>Deactive</option>
            </select>
            <Error field="status" />
          </div>
          <div className="row">
            <div className="col-5 offset-2 offset-sm-4 col-sm-4">
              <Button
                onClick={e => StaffHandler(e)}
                type="submit"
                className="btn form-button modaladdbutton"
                disabled={isValid ? false : true}
              >
                {isEdit ? "Update" : "Add"}
              </Button>
            </div>
            <div className="col-5 col-sm-4">
              <Button
                onClick={() => {
                  onClose();
                }}
                className="btn form-button modalcancelbutton"
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </ModalBody>
      {loading && <Loader />}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  // withRouter,
  enhancer,
  connect(mapStateToProps, { success, error })
)(StaffModal);
